import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { config, setToken } from '../../config/Config';
import { handleMessage } from '../../helper/utils';
import axios from 'axios';

export default function VerifyOtp({ email, expiredAfter, setCheckOtp }) {
  const { t } = useTranslation();
  const [passKey, setPassKey] = useState('');
  const [errors, setErrors] = useState({});
  const [timeLeft, setTimeLeft] = useState(expiredAfter);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isErrors = {};
    if (!passKey || passKey.length <= 0) {
      isErrors = {
        ...isErrors,
        passKey: t('passKey_not_empty'),
      };
    }

    if (isErrors.passKey) {
      setErrors(isErrors);
      return false;
    }
    try {
      const response = await axios.post(config.API_URL.AUTH.LOGIN_V2_OTP, { passKey, email });
      const { data } = response;
      await setToken(data.token);
      if (response?.status === 200) {
        window.location.href = '/';
      } else {
        handleMessage('error', 'OTP not match or expired');
      }
    } catch (errors) {
      handleMessage('error', 'OTP not match or expired');
    }
  };

  useEffect(() => {
    if (timeLeft <= 0) return setCheckOtp(false);

    const timerValue = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timerValue);
  }, [timeLeft]);

  return (
    <form className="login" onSubmit={handleSubmit} style={{ direction: 'rtl' }}>
      <input
        type="text"
        placeholder={t('passKey')}
        name="passKey"
        onChange={(e) => setPassKey(e.target.value)}
        value={passKey}
      />
      <p>
        An OTP code has been sent to your phone and will expire in{' '}
        <span className="font-medium text-red-500">{timeLeft}</span> seconds
      </p>
      {errors.passKey?.length > 0 && (
        <p style={{ color: 'rgba(244, 91, 105, 1)' }}>{errors.passKey}</p>
      )}

      <button type="submit" onClick={handleSubmit}>
        {t('confirm_button')}
      </button>
    </form>
  );
}
